const steps = [
  {
    number: '01',
    icon: 'ri-shopping-cart-2-line',
    title: 'Haz clic en el botón de compra',
    description: 'Presiona cualquier botón "¡COMPRAR AHORA!" y completa tu pago único de S/ 10.00. Es rápido y seguro.',
  },
  {
    number: '02',
    icon: 'ri-mail-send-line',
    title: 'Recibe tus credenciales',
    description: 'Inmediatamente después del pago, recibirás un mensaje con todas las credenciales de acceso a tu ecosistema digital.',
  },
  {
    number: '03',
    icon: 'ri-login-circle-line',
    title: 'Inicia sesión en cada herramienta',
    description: 'Usa las credenciales enviadas para ingresar a ChatGPT Plus, CapCut PRO, Filmora PRO, Canva PRO y todos tus bonos.',
  },
  {
    number: '04',
    icon: 'ri-rocket-2-line',
    title: '¡Empieza a facturar!',
    description: 'Desde cualquier dispositivo — laptop, PC, celular o tablet — ya tienes acceso total por un año completo.',
  },
];

export default function ComoAcceder() {
  return (
    <section id="como-acceder" className="relative py-20 md:py-24 px-4 bg-[#0d0d0d] overflow-hidden">
      {/* Background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[400px] h-[250px] md:w-[700px] md:h-[300px] bg-[#8b5cf6]/10 rounded-full blur-[100px] pointer-events-none" />

      <div className="max-w-5xl mx-auto relative z-10">
        {/* Header */}
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block bg-[#8b5cf6]/20 text-[#a78bfa] text-xs font-semibold tracking-widest uppercase px-4 py-2 rounded-full border border-[#8b5cf6]/30 mb-4">
            Proceso de acceso
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-extrabold text-white leading-tight mb-3 md:mb-4">
            ¿Cómo accedes a{' '}
            <span className="bg-gradient-to-r from-[#8b5cf6] to-[#10b981] bg-clip-text text-transparent">
              todo el Pack?
            </span>
          </h2>
          <p className="text-gray-400 text-base md:text-lg max-w-2xl mx-auto">
            Es más fácil de lo que imaginas. En menos de 5 minutos ya tienes acceso a todo tu ecosistema digital.
          </p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-16 md:mb-20">
          {steps.map((step, index) => (
            <div
              key={step.number}
              className="relative group bg-[#111111] border border-[#1f2937] rounded-2xl p-5 md:p-6 flex flex-col items-start gap-3 md:gap-4 hover:border-[#8b5cf6]/60 transition-all duration-300"
            >
              {/* Connector line (desktop) */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-10 -right-3 w-6 h-[2px] bg-gradient-to-r from-[#8b5cf6]/50 to-transparent z-20" />
              )}

              {/* Step number */}
              <span className="text-4xl md:text-5xl font-black text-[#8b5cf6]/15 leading-none select-none absolute top-3 right-4 md:top-4 md:right-5">
                {step.number}
              </span>

              {/* Icon */}
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-xl bg-[#8b5cf6]/15 border border-[#8b5cf6]/30 group-hover:bg-[#8b5cf6]/25 transition-colors">
                <i className={`${step.icon} text-[#a78bfa] text-lg md:text-xl`} />
              </div>

              {/* Text */}
              <div>
                <h3 className="text-white font-bold text-sm md:text-base mb-1">{step.title}</h3>
                <p className="text-gray-400 text-xs md:text-sm leading-relaxed">{step.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Video Section */}
        <div className="relative">
          <div className="text-center mb-6 md:mb-8">
            <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-white mb-2">
              Mira cómo funciona en{' '}
              <span className="text-[#10b981]">tiempo real</span>
            </h3>
            <p className="text-gray-400 text-sm md:text-base">
              Ve el proceso completo de acceso y cómo usar cada herramienta del pack.
            </p>
          </div>

          {/* Video wrapper */}
          <div className="relative rounded-2xl overflow-hidden border border-[#8b5cf6]/30 shadow-[0_0_60px_rgba(139,92,246,0.15)]">
            <div className="absolute inset-0 rounded-2xl bg-gradient-to-r from-[#8b5cf6]/20 via-transparent to-[#10b981]/20 pointer-events-none z-10" />
            <div className="aspect-video w-full">
              <iframe
                src="https://www.youtube.com/embed/Y0sYgdNqVyg?rel=0&modestbranding=1&color=white"
                title="Cómo acceder al Super Pack Digital"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                className="w-full h-full"
                style={{ border: 'none' }}
              />
            </div>
          </div>

          {/* Bottom CTA after video */}
          <div className="text-center mt-8 md:mt-10">
            <a
              href="https://wa.link/3odpj7"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-2 bg-gradient-to-r from-[#8b5cf6] to-[#10b981] text-white font-extrabold text-base md:text-lg px-7 md:px-10 py-4 rounded-full cursor-pointer hover:scale-105 hover:shadow-[0_0_30px_rgba(139,92,246,0.5)] transition-all duration-300 text-center leading-snug"
            >
              <span>¡QUIERO MI ACCESO AHORA</span>
              <span>POR S/ 10.00!</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
